class ChangeCollapse {
    constructor() {
        this.Selectors = {
            changable: '[data-toggle="changeCollapse"]'
        };
        this.Options = {
            targetDataKey: 'target',
                hideElementForSelectionDataKey: 'hideFor'
        };

        let $changables = $(this.Selectors.changable);
        $changables.each(function(index, changable) {
            let $changable = $(changable);
            $($changable.data(this.Options.targetDataKey)).each(function(index, element) {
                let $element = $(element);
                $element.addClass('collapse');
                if(this.shouldBeVisible($element, $changable.val())) {
                    $element.addClass('in');
                    $element.collapse('show');
                } else {
                    $element.collapse('hide');
                }
            }.bind(this));

            $changable.on('change', function (e) {
                this.onChangableChange($changable)
            }.bind(this));
            if($changable.is(':selected, :checked, select')) {
                $changable.trigger('change');
            }
        }.bind(this));
    }

    onChangableChange($changable) {
        let $elementsToHide = $($changable.data(this.Options.targetDataKey));

        $elementsToHide.each(function(index, element) {
            var $element = $(element);
            if(this.shouldBeVisible($element, $changable.val())) {
                $element.collapse('show');
            } else {
                $element.collapse('hide');
            }
        }.bind(this));
    }

    shouldBeVisible($element, value) {
        let index = $element.data(this.Options.hideElementForSelectionDataKey)
            .indexOf(value);
        return index === -1;
    }
}

export default ChangeCollapse;